
export function reloadWindowCallback() {
    window.location.reload();
}

export function reloadWindowPromise(): Promise<void> {
    window.location.reload();
    return Promise.resolve();
}
